import { memo } from "react";
import { Loader2 } from "lucide-react";
import { websiteUrls } from "@/lib/site-urls";
import { RefreshButton } from "../buttons/RefreshButton";

export const LandingNotices = memo(function LandingNotices({
  disconnected,
}: {
  disconnected?: boolean;
}) {
  return (
    <div className="mt-6 flex flex-col items-center justify-center gap-4 px-4">
      {disconnected && (
        <div className="flex w-full items-center gap-2.5 rounded-xl border border-red-500/20 bg-red-500/[0.06] px-3 py-2 text-[13px] text-red-200/90">
          <Loader2 className="h-4 w-4 shrink-0 animate-spin text-red-400/80" />
          <span className="flex-1 leading-snug">
            Lost connection to server. Reconnecting&hellip;
          </span>
          <RefreshButton onClick={() => window.location.reload()} />
        </div>
      )}

      <div className="max-w-2xl text-center text-[12px] leading-relaxed text-zinc-500">
        <p>
          By using Agentica you agree to our{" "}
          <a
            href={websiteUrls.termsOfUse}
            target="_blank"
            rel="noopener noreferrer"
            className="underline transition-colors hover:text-zinc-300"
          >
            Terms of Use
          </a>{" "}
          and{" "}
          <a
            href={websiteUrls.privacyPolicy}
            target="_blank"
            rel="noopener noreferrer"
            className="underline transition-colors hover:text-zinc-300"
          >
            Privacy Policy
          </a>
          .
        </p>
        <p className="mt-1.5 text-zinc-600">
          Agentica may experience stability issues. Agents may disconnect. We
          recommend saving important work locally.
        </p>
      </div>
    </div>
  );
});
